import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const ShirtManufacturingInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Shirt Manufacturing Section"
    sectionKey="Shirt Manufacturing"
    backRoute="/sections/shirt-manufacturing"
  />
);

export default ShirtManufacturingInternalTransfer;
